{
  "loading": "Laden...",
  "loadingMore": "Meer laden..."
}